import React from 'react';
import { useContext, useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from '../../Utils/routes';
import { getAxiosInstance, getConfig } from '../../Utils/apiService';
import { useAppContext } from '../../Helpers/Contexts/appContext';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import KenLoader from '../../GlobalComponents/KenLoader';
import axios from 'axios';
import { KEY_AZURE_TOKEN } from '../../Helpers/constant';
import { ConfigOptions } from '../../interfaces/Common';
import AuthLayout from '../../Components/AuthLayout';
import AppLayout from '../../Components/AppLayout';
import { FacultyOnlyRoute, PrivateRoute, PublicRoute, StudentOnlyRoute } from '../../Utils/helperFunctions';
import storage from '../../storageService';
import FAQ from '../Service/components/FAQ';
import EditProfile from '../MyProfile/Components/PersonalDetails/Pages/EditProfile';
import Answers from '../Service/components/Questions/Answers';
import AssessmentAdding from '../Academics/Pages/Activities/Assessment/List';
import AssessmentView from '../Academics/Pages/Activities/Assessment/View';
import AssessmentCreate from '../Academics/Pages/Activities/Assessment/Create';
import AssessmentResponse from '../Academics/Pages/Activities/Assessment/Response';
import AssignmentForm from '../Academics/Pages/Activities/Assignment';
import AssignmentReview from '../Academics/Pages/Activities/Assignment/Components/Preview';
import DiscussionPortal from '../Academics/Pages/Activities/Forum/ForumDiscussions/ForumDiscussion';
// import PageViewTracker from '../../MixPanel/PageViewTracker';
const ResourceFormComponent = React.lazy(() => import('../Academics/Components/ResourceFileUpload/index'));
const Home = React.lazy(() => import('../../Containers/Home/index'))
const AcademicsElaborate = React.lazy(() => import('../Academics/Pages/AcademicsElaborate'));
const CourseElaborate = React.lazy(() => import('../Academics/Pages/CourseElaborate'));
const CourseDetail = React.lazy(() => import('../Academics/Pages/CourseDetail'));
const Signup = React.lazy(() => import('../Auth/SignUp/index'));
const StudentRegister = React.lazy(() => import('../Auth/StudentRegister/index'));
const VerifyOTP = React.lazy(() => import('../Auth/VerifyOtp/index'));
const EmailConformation = React.lazy(() => import('../Auth/ConfirmEmail/index'));
const Login = React.lazy(() => import('../Auth/Login/index'));
const ForgotPassword = React.lazy(() => import('../Auth/ForgotPassword/index'));
const ConfirmPassword = React.lazy(() => import('../Auth/ConfirmPassword/index'));
const Events = React.lazy(() => import('../Events/index'));
const Academics = React.lazy(() => import('../../Containers/Academics'))
const QuestionBank = React.lazy(() => import('../Academics/QuestionBank/index'))
const Service = React.lazy(() => import('../Service/index'));
const TicketPreview = React.lazy(() => import('../Service/components/Ticket/TicketPreview'));
const RequestService = React.lazy(() => import('../Service/components/Requests/RequestService'));
const Test = React.lazy(() => import('../Test'));
const Settings = React.lazy(() => import('../Settings/index'));
const MyStudents = React.lazy(() => import('../MyStudents'));
const Mentoring = React.lazy(() => import('../Mentoring'));
const MySchedule = React.lazy(() => import('../MySchedule/index'))
const MyResourceEloborate = React.lazy(() => import('../Academics/Pages/resourceEloborateView'))
const StudentDetails = React.lazy(() => import('../MyStudents/Pages/studentdetails'));
const StudentInfo = React.lazy(() => import('../MyStudents/Pages/studentinfo'));
const AttendanceTabs = React.lazy(() => import('../Attendance/Tabs/index'));
const Attendance = React.lazy(() => import('../Attendance/index'));
const OverAllAttendance = React.lazy(() => import('../Attendance/components/overallAttendance'));
const FacultyCourses = React.lazy(() => import('../Attendance/Tabs/facultycourses'));
const MyProfile = React.lazy(() => import('../MyProfile'));
const PlanMyProgram = React.lazy(() => import('../PlanMyProgram/index'));
const SessionPlanner = React.lazy(() => import('../PlanMyProgram/Pages/sessionPlanner'));
const SessionSummary = React.lazy(() => import('../PlanMyProgram/Pages/sessionsummary'));
const AcademicsaddQuestion = React.lazy(() => import('../Academics/QuestionBank/AddQuestion/index'));
const StudentPortal = React.lazy(() => import('../StudentPortal/index'));
const StudentPortalCourses = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalCourses })));
const StudentPortalCourseContent = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalCourseContent })));
const StudentPortalActivities = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalActivities })));
const StudentPortalTests = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalTests })));
const StudentPortalTestForm = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalTestForm })));
const StudentPortalArtifacts = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalArtifacts })));
const StudentPortalCertificates = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalCertificates })));
const StudentPortalAttendance = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalAttendance })));
const StudentPortalTimetable = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalTimetable })));
const StudentPortalMentoring = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalMentoring })));
const StudentPortalForum = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalForum })));
const StudentPortalProfile = React.lazy(() => import('../StudentPortal/index').then((m) => ({ default: m.StudentPortalProfile })));

const HomeRouter: React.FunctionComponent = () => {
  const { state: { user } } = useContext(AuthContext);
  const isStudent = (user as any)?.Type?.toLowerCase() === 'student';
  return isStudent ? <StudentPortal /> : <Home />;
};


const MainLayout: React.FunctionComponent = () => {
  const {
    dispatch,
    state: { config },
  } = useAppContext();

  const [forgotPassword, setForgotPassword] = useState(false);
  useEffect(() => {
    getConfig()
      .then((res: Array<ConfigOptions>) => {
        console.log('getConfig response:', res);
        dispatch({ type: 'updateConfig', value: res[0]?.config });
        dispatch({ type: 'updateLogo', value: res[0]?.config?.logoURL });
        getAxiosInstance(res);
        console.log('Passed to getAxiosInstance:', res);
        try {
          axios({ method: 'get', baseURL: res[0]?.config?.tokenUrl })
            .then((response: any) => {
              // localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
              storage.set(KEY_AZURE_TOKEN, response.data.access_token);
            })
            .catch((err) => {
              return err;
            });
        } catch (err) {
          console.error(err);
        }
      })
      .catch((err) => {
        console.error('error in config', err);
      });
  }, []);
  

  return config.apiBaseUrl === '' ? (
    <KenLoader />
  ) : (
    <>
      {/* <PageViewTracker /> */}
      <Routes>
        {/* Initial Route */}
        <Route path="/" element={<Navigate to={routes.login} />} />
        <Route path="/test" element={<Test />} />

        {/* Public Routes */}
        <Route
          path={routes.login}
          index
          element={
            <PublicRoute>
              <AuthLayout>
                <Login />
              </AuthLayout>
            </PublicRoute>
          }
        />

        <Route
          path={routes.otpverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <VerifyOTP />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.emailverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <EmailConformation />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.forgotPassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ForgotPassword setForgotPassword={setForgotPassword} />
              </AuthLayout>
            </PublicRoute>
          }
        />
        {/* Old single-step signup form — submission is disabled (see SignUp/index.tsx).
            Kept mounted at /signup per existing links; new student registration
            wizard lives at routes.register below. Do not remove until product
            confirms the old flow (enrollment number / graduation year) is retired. */}
        <Route
          path={routes.signup}
          element={
            <PublicRoute>
              <AuthLayout>
                <Signup />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.register}
          element={
            <PublicRoute>
              <AuthLayout>
                <StudentRegister />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.changePassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ConfirmPassword />
              </AuthLayout>
            </PublicRoute>
          }
        />
        {/* home */}
        <Route
          path={routes.home}
          element={
            <PrivateRoute>
              <AppLayout>
                <HomeRouter />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Academics */}
        <Route
          path={routes.academics}
          element={
            <PrivateRoute>
              <AppLayout>
                <Academics />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.academicsElaborate}
          element={
            <PrivateRoute>
              <AppLayout>
                <AcademicsElaborate />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.courseElaborate}
          element={
            <PrivateRoute>
              <AppLayout>
                <CourseElaborate />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.courseDetail}
          element={
            <PrivateRoute>
              <AppLayout>
                <CourseDetail />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.resourceUpload}
          element={
            <PrivateRoute>
              <AppLayout>
                <ResourceFormComponent />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route path={routes.resourceEloboarate}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyResourceEloborate />
              </AppLayout>
            </PrivateRoute>
          } />
        <Route
          path={routes.AssessmentAdding}
          element={
            <PrivateRoute>
              <AppLayout>
                <AssessmentAdding />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.AssessmentView}
          element={
            <PrivateRoute>
              <AppLayout>
                <AssessmentView />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.AssessmentCreate}
          element={
            <PrivateRoute>
              <AppLayout>
                <AssessmentCreate />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.AssessmentResponse}
          element={
            <PrivateRoute>
              <AppLayout>
                <AssessmentResponse />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.AssignmentAdding}
          element={
            <PrivateRoute>
              <AppLayout>
                <AssignmentForm />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.AssignmentReview}
          element={
            <PrivateRoute>
              <AppLayout>
                <AssignmentReview />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.ForumDiscussion}
          element={
            <PrivateRoute>
              <AppLayout>
                <DiscussionPortal />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.QuestionBank}
          element={
            <PrivateRoute>
              <AppLayout>
                <QuestionBank />
              </AppLayout>
            </PrivateRoute>
          }
        />
         <Route
          path={routes.Addquestion}
          element={
            <PrivateRoute>
              <AppLayout>
                <AcademicsaddQuestion />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* My Students */}
        <Route
          path={routes.studentDetails}
          element={
            <PrivateRoute>
              <AppLayout>
                <StudentDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.studentInfo}
          element={
            <PrivateRoute>
              <AppLayout>
                <StudentInfo />
              </AppLayout>
            </PrivateRoute>
          }
        />        <Route
          path={routes.myProfile}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyProfile />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.EditProfile}
          element={
            <PrivateRoute>
              <AppLayout>
                <EditProfile />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Plan My program */}
        <Route
          path={routes.PlanMyProgram}
          element={
            <PrivateRoute>
              <AppLayout>
                <PlanMyProgram />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.SessionPlanner}
          element={
            <PrivateRoute>
              <AppLayout>
                <SessionPlanner />
              </AppLayout>
            </PrivateRoute>
          }
        />
         <Route
          path={routes.SessionSummary}
          element={
            <PrivateRoute>
              <AppLayout>
                <SessionSummary />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* My Students */}
        <Route
          path={routes.myStudents}
          element={
            <FacultyOnlyRoute>
              <AppLayout>
                <MyStudents />
              </AppLayout>
            </FacultyOnlyRoute>
          }
        />
        {/* Mentoring */}
        <Route
          path={routes.mentoring}
          element={
            <FacultyOnlyRoute>
              <AppLayout>
                <Mentoring />
              </AppLayout>
            </FacultyOnlyRoute>
          }
        />
        {/* Attendance */}
        <Route
          path={routes.attendanceTabs}
          element={
            <FacultyOnlyRoute>
              <AppLayout>
                <AttendanceTabs />
              </AppLayout>
            </FacultyOnlyRoute>
          }
        />
        <Route
          path={routes.attendance}
          element={
            <FacultyOnlyRoute>
              <AppLayout>
                <Attendance />
              </AppLayout>
            </FacultyOnlyRoute>
          }
        />
        <Route
          path={routes.facultyCourses}
          element={
            <PrivateRoute>
              <AppLayout>
                <FacultyCourses />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.overAllAttendance}
          element={
            <PrivateRoute>
              <AppLayout>
                <OverAllAttendance />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* My Schedule */}
        <Route
          path={routes.mySchedule}
          element={
            <PrivateRoute>
              <AppLayout>
                <MySchedule />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Student Portal */}
        <Route
          path={routes.studentPortal}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortal />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalCourses}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalCourses />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalCourseContent}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalCourseContent />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalActivities}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalActivities />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalTests}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalTests />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalTestForm}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalTestForm />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalArtifacts}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalArtifacts />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalCertificates}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalCertificates />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalAttendance}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalAttendance />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalTimetable}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalTimetable />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalMentoring}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalMentoring />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalForum}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalForum />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        <Route
          path={routes.studentPortalProfile}
          element={
            <StudentOnlyRoute>
              <AppLayout>
                <StudentPortalProfile />
              </AppLayout>
            </StudentOnlyRoute>
          }
        />
        {/* Events */}
        <Route
          path={`events/*`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Events />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* settings */}
        <Route
          path={`${routes.settings}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Settings />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Service and Support */}

        <Route
          path={`${routes.service}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Service />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.serviceFAQ}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <FAQ />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.RequestService}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <RequestService />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.Answers}/:serviceId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Answers />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.TicketPreview}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <TicketPreview />
              </AppLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
};

export default MainLayout;
